/* eslint-disable */
import Vue from 'vue'
let cityMapping = require('@/plugins/city-map/cityMap.json')

class CityMap {
  country:any = {
    name: null,
    iso: null,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    offset: null
  }

  constructor () {
    this.lookupViaTimezone()
  }

  lookupViaTimezone () {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const cityM = cityMapping.find((cityM:any) => cityM.timezone && cityM.timezone.includes(timezone))

    if (!cityM) {
      console.log('No country')
      return false
    }

    this.country = {
      name: cityM.country,
      iso: cityM.iso2,
      timezone: cityM.timezone,
      offset: cityM.offset ? cityM.offset : null
    }

    // const iconPrefix = process.env.VUE_APP_AWS_S3_URL
    // icon: `${iconPrefix}/icons/country-flag/svg/${cityM.iso2.toLowerCase()}.svg`
    // https://ocular-dev.s3.us-east-2.amazonaws.com/icons/country-flag/svg/VE.svg

    return this.country
  }
}
export default new CityMap()
Vue.prototype.$cityMap = new CityMap()
